<template>
    <v-sheet v-bind="$attrs">
        <v-date-picker v-model="date" v-bind="{ events, weekdayFormat }" show-adjacent-months format event-color="primary" no-title locale="en" @input="emit" />
    </v-sheet>
</template>

<script>
import dayjs from "dayjs";
export default {
    props: {
        value: { type: String, default: Date.now().toDate() },
        events: { type: Function, default: () => () => {} },
    },
    data: () => ({
        date: Date.now().toDate(),
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.date = this.value;
        },
        emit() {
            this.$emit("input", this.date);
        },
        weekdayFormat(date) {
            return ["일", "월", "화", "수", "목", "금", "토"][dayjs(date).day()];
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .v-date-picker-table{
        padding: 0;
    }
    .v-date-picker-header{
        padding: 0;
        margin-bottom: 12px;
        justify-content: flex-end;
        &__value{
            position: absolute;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
            max-width: calc(100% - 70px);
            button{
                font-weight: 500;
                font-size: 1.6rem;
            }
        }
        .theme--light.v-icon{
            color: #131313;
        }
        .v-btn.v-size--default{
            width: 24px;
            height: 24px;
            background-color: transparent !important;
            &::before{
                display: none;
            }
        }
        .v-btn.v-size--default:first-child{
            margin-right: 10px;
        }
    }
    .v-date-picker-table{
        thead{
            position: relative;
            tr{
                position: relative;
                z-index: 1;
                th{
                    color: #131313;
                    height: 36px;
                    font-weight: 400;
                    font-size: 1.2rem;
                }
            }
            &::before{
                content: "";
                display: block;
                position: absolute;
                width: 100%;
                height: 100%;
                border-radius: 4px;
                background-color: #F1F2F6;
                top: 0;
                left: 0;
                z-index: 0;
            }            
        }
        td{
            height: 44px;
            button:not(.v-date-picker-table--month button){
                font-size: 1.4rem;
                width: 28px;
                height: 28px;
                border-radius: 50% !important;
                font-weight: 400;
                margin: 0 auto;
                color: #131313;
                &.v-btn--disabled{
                    color: #999 !important;
                }
            }
        }
    }
    .v-date-picker-table--date tr th:first-child, .v-date-picker-table--date tr td:first-child .v-btn:not(.accent){
        color: #E26262;
    }
    .v-date-picker-table--date tr th:last-child, .v-date-picker-table--date tr td:last-child .v-btn:not(.accent) {
        color: #0F98A1;
    }
    .v-btn.accent{
        color: #fff !important;
    }
}

@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    ::v-deep {
        .v-date-picker-header{
            justify-content: flex-end;
            &__value{
                max-width: calc(100% - 80px);
                button{
                    font-size: 2rem;
                }
            }
            .v-btn.v-size--default:first-child{
                margin-right: 20px;
            }
        }
        .v-date-picker-table{
            thead{
                tr{
                    th{
                        height: 42px;
                        font-size: 1.4rem;
                    }
                }
                &::before{
                    border-radius: 6px;
                }            
            }
            td{
                height: 52px;
                button:not(.v-date-picker-table--month button){
                    font-size: 1.8rem;
                    width: 40px;
                    height: 40px;
                }
            }
        }
    }
}
@media (min-width:1200px){
}

</style>
